import React from 'react';
import './Loading.css';

const Loading = () => {
  return (
    <div className="loading-screen">
      <div className="loading-content">
        <div className="loading-spinner">
          <div className="spinner-circle"></div>
          <div className="spinner-logo">E</div>
        </div>
        <h2 className="loading-text">Elexyt Technologies</h2>
      </div>
    </div>
  );
};

export default Loading;